import { render } from "./Bill.vue?vue&type=template&id=8d0e6dd6&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"

import "./Bill.vue?vue&type=style&index=0&id=8d0e6dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0e6dd6"]])

export default __exports__